import { h } from 'preact';
import * as BaseComp from 'components/bolt/tiledItems/tile/tile.js';
import Store from 'store/store';
import { isVideosPage } from 'utils/bolt';
import { smoothScrollTo } from 'utils/smoothScroll';
import { accessNested } from 'utils/utils';

import s from 'components/bolt/tiledItems/tile/tile.sss';

export default class Tile extends BaseComp.default {
	async triggerAction(path) {
		let newPath = path;
		let queryString = '';

		if (path.includes('?v=')) {
			const stringArray = path.split('?v=');
			newPath = stringArray[0];
			queryString = '?v=' + stringArray[1];
		}

		if (path.includes('?m=')) {
			const stringArray = path.split('?m=');
			newPath = stringArray[0];
			queryString = '?m=' + stringArray[1];
		}

		if (newPath === 'applicationForm') {
			const tileTitle = this.props?.data?.title;
			if (tileTitle) {
				Store.get().set({ input_3: tileTitle });
			}
			Store.get().set({ scrollToApplicationForm: true });
		}

		// We should use navigateInternally from utils/bolt here
		if (path.startsWith('@')) {
			return Store.emit('OPEN_RESERVED_VARIABLE_LINK', path);
		} else if (isVideosPage(newPath)) {
			return Store.emit('OPEN_VIDEO_OVERLAY', newPath, queryString);
		} else if (path.includes('boltShowtimes')) {
			return Store.emit('SHOWTIMES_SHOW', true, queryString);
		} else if (path === 'boltHomeEnt') {
			return Store.emit('HOMEENT_SHOW', true);
		} else if (path === 'scrollTop') {
			smoothScrollTo(document.getElementById('mainScroll'), 0, 300);
		} else {
			const isSection = accessNested(Store.get(), `appData.pages.${path}.section`, false);

			if (isSection) {
				return Store.emit('CHANGE_ACTIVE_SECTION', path);
			}

			// await animation(mainScroll, 'left', 400);
			return Store.emit('SET_ACTIVE_PAGE', path);
		}
	}

	renderButton(button) {
		const link = button.link?.trim() || button.file?.trim() || '';
		const tileName = this.props?.data?.title || button.label;

		const content = [
			<span>{button.label}</span>,
			button.icon && <img class={s.icon} src={button.icon} alt="" />
		];

		if (/^(https?|mailto):/.test(link)) {
			return (
				<a class={s.cta} href={link} target="_blank" title={button.title} onClick={() => this.fireEvent('tileditem-cta-click', 'tileditems', tileName + ' - ' + link)}>
					{content}
				</a>
			);
		}

		return (
			<button
				class={s.cta}
				title={button.title}
				onClick={() => {
					this.fireEvent(
						'tileditem-cta-click',
						'tileditems',
						tileName + ' - ' + link
					);
					this.triggerAction(link);
				}}
			>
				{content}
			</button>
		);
	}

	render(props, state) {
		const originalButtons = props?.data?.ctaButtons || {};
		const ctaButtons = Array.isArray(originalButtons)
			? [...originalButtons]
			: Object.values(originalButtons);

		const applyNowButton = {
			label: 'Apply Now',
			link: 'applicationForm',
			order: -1
		};

		const alreadyHasApplyNow = ctaButtons.some(
			btn => btn.label === applyNowButton.label && btn.link === applyNowButton.link
		);

		if (!alreadyHasApplyNow) {
			ctaButtons.push(applyNowButton);
		}

		const newProps = {
			...props,
			data: {
				...props.data,
				ctaButtons
			}
		};

		return super.render(newProps, state);
	}
}